<template>
  <div v-if="!isBookshelfLoading && getCurrentBookshelf" class="location_wrap">
    <!-- <div v-if="regiBox" class="receive_registration" @click="openRegi">
      <div class="left_sec">
        <span>받은 도서 등록하기</span>
        <p>도서가 보이지 않나요? 링크로 직접 등록해보세요.</p>
      </div>
      <button class="cancel_btn" @click.stop="noneRegiBox">
        <span></span>
        <span></span>
      </button>
    </div> -->
    <div class="locate_wrap">
      <div class="location">
        <span>{{ $t('library.subbar.7204') }}</span>
        <span class="svg_next">></span>
        <span>{{ $t('library.subbar.1465') }}</span>
        <span class="svg_next">></span>

        <div v-on-clickaway="closeListMenu" class="current">
          <div class="select_area">
            <div :class="{ active: isListMenuOpen }" class="select_item">
              <button
                v-if="!isBookshelfLoading"
                type="button"
                class="select_option"
                @click.prevent.stop="toggleListMenu"
              >
                <template v-if="$route.path === '/library'">
                  <span class="txt">전체도서</span
                  ><span class="arrow blind">열기</span>
                </template>
                <template v-else>
                  <span class="txt">{{ getCurrentBookshelf.name }}</span>
                  <span class="arrow blind">열기</span>
                </template>
              </button>

              <ul v-if="isListMenuOpen" class="select_list">
                <li v-for="(bookshelf, index) in baseBookshelves" :key="index">
                  <a @click="navigateBookshelf(bookshelf.id)">
                    {{ bookshelf.name }}
                  </a>
                </li>
              </ul>
              <template v-if="isLibraryDetail">
                <span class="svg_next ml-1">></span>
                <span class="txt">{{
                  $t('views.library.librarybookdetail.6338')
                }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isLibraryDetail" class="eplist_sort">
        <div class="btn_wrap">
          <div
            v-if="
              !isMoveBookModeEnabled &&
              getCurrentBookshelf.bookshelfTp !== 'DBS' &&
              getCurrentBookshelfBooks &&
              getCurrentBookshelfBooks.length > 0
            "
            class="edit_shelf btn"
            @click="copyBook"
          >
            책 추가하기
          </div>
          <div
            v-if="
              isMoveBookModeEnabled && getCurrentBookshelf.bookshelfTp !== 'DBS'
            "
            class="flex"
          >
            <div class="library_option cancel" @click="endSelectMode">
              <button type="button" class="btn">
                <span class="an_t">취소</span>
              </button>
            </div>
            <div class="library_option ml-1 add" @click="moveLibraryBooks">
              <button
                type="button"
                class="btn"
                :class="!getSelectedLibraryBooks.length ? 'disabled' : ''"
              >
                <span class="an_t num_add">
                  {{ getSelectedLibraryBooks.length }}개 추가
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- SLOT CONTENTS -->
  <!-- <slot /> -->
</template>

<script>
import { mapGetters } from 'vuex'
import { isNiaMode } from '@/store/constants'

import {
  BOOKSHELF_SET_CURRENT,
  BOOKSHELF_BOOK_MOVE_BOOKS,
  UI_SHOW_SIDEBAR,
  UI_ENABLE_MOVE_BOOK_MODE,
  UI_DISABLE_MOVE_BOOK_MODE,
  UI_UNSELECT_ALL_BOOKS
} from '@/store/types'

export default {
  name: 'Subbar',
  data() {
    return {
      isListMenuOpen: false,
      isMoveListMenuOpen: false,
      activeFilter: 'PD',
      isNiaMode,
      isAddingBooks: false,
      regiBox: localStorage.getItem('hideRegiBox') !== 'true'
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelf',
      'getBookshelves',
      'isBookshelfLoading',
      'isSidebarOpen',
      'isMoveBookModeEnabled',
      'getSelectedLibraryBooks',
      'getCurrentBookshelfBooks',
      'getCurrentUser'
    ]),
    isLibraryDetail() {
      return this.$route.name === 'library_book_detail'
    },
    baseBookshelves() {
      return this.getBookshelves.filter(
        (e) =>
          e.bookshelfTp !== 'GFT' &&
          e.bookshelfTp !== 'PRS' &&
          e.bookshelfTp !== 'CPN'
      )
    },
    allBookshelves() {
      return this.getBookshelves.filter((e) => e.bookshelfTp === 'DBS')
    },
    filteredBookshelves() {
      return this.getBookshelves.filter((e) => e.bookshelfTp !== 'DBS')
    },
    selectedFilterTypes() {
      const selected = []

      if (this.filters.purchase) selected.push('PMT')
      if (this.filters.freebie) selected.push('PRS')
      if (this.filters.trial) selected.push('CPN')
      if (this.filters.receivedGift) selected.push('GFT')
      if (this.filters.expired) selected.push('EXPIRED')

      return selected
    }
  },
  watch: {
    filters: {
      handler() {
        this.$emit('filter-changed', this.selectedFilterTypes)
      },
      deep: true
    }
  },
  mounted() {
    if (this.getCurrentBookshelf) {
      return
    } else {
      const rp = this.$route.params.id
      this.navigateBookshelf(rp)
    }

    this.$nextTick(() => {
      this.$emit('filter-changed', this.selectedFilterTypes)
    })
  },
  beforeDestroy() {
    this.endSelectMode()
  },
  methods: {
    navigateBookshelf(id) {
      this.$store.commit(BOOKSHELF_SET_CURRENT, id)
      if (id !== '') {
        this.$router.push({ name: 'library', params: { id } })
      } else {
        this.$router.push({ name: 'library_default' })
      }
      this.$emit('reset-search')
      this.closeListMenu()
    },
    openSidebar() {
      this.$store.commit(UI_SHOW_SIDEBAR)
    },
    toggleListMenu() {
      this.isListMenuOpen = !this.isListMenuOpen
    },
    toggleMoveListMenu() {
      if (this.getSelectedLibraryBooks.length > 0) {
        this.isMoveListMenuOpen = !this.isMoveListMenuOpen
      }
    },
    closeMoveListMenu() {
      this.isMoveListMenuOpen = false
    },
    closeListMenu() {
      this.isListMenuOpen = false
    },
    startSelectMode() {
      this.$store.commit(UI_ENABLE_MOVE_BOOK_MODE)
    },
    async endSelectMode() {
      this.$store.commit(UI_UNSELECT_ALL_BOOKS)
      this.$store.commit(UI_DISABLE_MOVE_BOOK_MODE)
      this.isAddingBooks = false
      this.$emit('filter-refresh')
      // 책 추가 모드가 아닌 일반 선택 모드 취소 시에만 default-books 이벤트를 발생
      if (!this.isAddingBooks) {
        this.$emit('reset-search')
        if (this.getCurrentUser) {
          this.$emit('books-added')
        }
      }
    },
    filterNotes(value) {
      this.activeFilter = value
      this.$emit('sort', value)
    },
    async moveLibraryBooks() {
      if (!this.getSelectedLibraryBooks.length) return

      await this.$store.dispatch(BOOKSHELF_BOOK_MOVE_BOOKS, {
        bookshelfId: this.allBookshelves[0].id,
        to: this.getCurrentBookshelf.id,
        books: this.getSelectedLibraryBooks
      })
      this.isAddingBooks = false
      this.$store.commit(UI_UNSELECT_ALL_BOOKS)
      this.$store.commit(UI_DISABLE_MOVE_BOOK_MODE)

      this.$root.$emit('bookshelf-counts-updated') // 책장 수 갱신
      this.$emit('books-added')
      this.$emit('reset-search')
    },
    handleOutsideClick(event) {
      if (
        this.isFilterListVisible &&
        this.$refs.filter &&
        !this.$refs.filter.contains(event.target)
      ) {
        this.isFilterListVisible = false
      }
    },
    copyBook() {
      this.$store.commit(UI_ENABLE_MOVE_BOOK_MODE)
      this.isAddingBooks = true
      this.$emit('show-all-books')
    },
    noneRegiBox() {
      this.regiBox = !this.regiBox
      // 로컬스토리지에 저장
      localStorage.setItem('hideRegiBox', 'true')
      this.$emit('show-regi-btn')
    },
    openRegi() {
      this.$emit('open-regi')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn_wrap {
  display: flex;
  align-items: center;
  gap: 25px;
  user-select: none;
  .filter {
    position: relative;
  }
  .filter_list {
    position: absolute;
    top: 36px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    width: 185px;
    padding: 15px 10px 15px 25px;
    background-color: #f0f5fa;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(34, 34, 34, 0.12);
    input {
      display: none;
      &:checked + label {
        &::before {
          background: url('../../assets/images/checkbox_on.png') no-repeat;
        }
      }
    }
    label {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 18px 0;
      font-size: 15px;
      font-weight: 400;
      cursor: pointer;
      color: #000;
      &::before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        background: url('../../assets/images/checkbox_off.png') no-repeat;
      }
    }
  }
  .filter {
    color: #155d81;
    .txt {
      font-weight: 400;
      color: #777;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    gap: 7px;
    height: 35px;
    font-family: 'pretendard-medium';
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
    cursor: pointer;
    &.edit_shelf {
      padding: 0 12px;
      background: #155d81;
      font-weight: 400;
      color: #fff;
      &::before {
        content: '+';
        line-height: 15px;
        font-size: 15px;
      }
    }
    i {
      width: 25px;
      height: 25px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
// .library_option.cancel .btn {
//   background: #155d81;
//   .an_t {
//     color: #fff;
//   }
// }
.library_option.add .btn {
  background: #155d81;
  .an_t {
    color: #fff;
  }
  &.disabled {
    background: #fff;
    .an_t {
      color: #125c83;
    }
  }
  .num_add {
    width: 55px;
  }
}
.move .select_list li,
.move .select_list a,
.move .select_list span,
.move .select_list .list_option {
  height: 48px;
  padding: 0 10px;
}
.move .select_list .tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  text-align: center;
  padding: 0 10px;
  font-size: 13px;
}
.move .select_list .select_list_close {
  position: static;
  width: initial;
  height: initial;
  margin-top: -1px;
}
.move .select_list a,
.move .select_list .list_option {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0;
  text-align: center;
}
.library_option.move .select_list {
  margin-left: 0;
  margin-top: 5px;
}
.locate_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  height: 35px;
}
.location {
  padding-bottom: 0;
}
.location_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // align-items: center;
  // height: 55px;
  margin-top: 40px;
  border-bottom: none;
  .eplist_sort {
    position: static;
    display: flex;
    align-items: center;
    .board_sort {
      margin-right: 24px;
    }
  }
}
.receive_registration {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #dddddd;
  border-radius: 16px;
  cursor: pointer;
  .left_sec {
    span {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-bottom: 10px;
      font-weight: 600;
      font-size: 16px;
      color: #3aa6c0;
      &::before {
        content: '';
        display: block;
        width: 3px;
        height: 3px;
        border-radius: 100%;
        background-color: #3aa6c0;
      }
    }
    p {
      position: relative;
      display: flex;
      align-items: center;
      gap: 5px;
      &::before {
        content: '';
        display: block;
        width: 15px;
        height: 15px;
        background: url('../../assets/images/feel.png') no-repeat;
        background-size: contain;
      }
      &::after {
        content: '';
        display: block;
        width: 11px;
        height: 11px;
        background: url('../../assets/images/arrow_right.png') no-repeat center
          center;
        background-size: contain;
      }
      color: #777777;
    }
  }
  .cancel_btn {
    position: relative;
    width: 27px;
    height: 27px;
    span {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      height: 2px;
      background-color: #3aa6c0;
      &:nth-child(1) {
        transform: rotate(-45deg);
      }
      &:nth-child(2) {
        transform: rotate(45deg);
      }
    }
  }
}
.ml-1 {
  margin-left: 8px;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
@media (min-width: 1024px) {
  .location_wrap.sub_bar_custom {
    max-width: 1120px;
  }
}
@media (max-width: 1024px) {
  .location_wrap {
    padding: 5px 20px 0px 20px;
  }
}
@media screen and (max-width: 768px) {
  .location_wrap {
    margin-top: 0;
    padding: 30px 20px 0px 20px;
    .eplist_sort {
      margin-top: 0;
      justify-content: space-between;
      .btn_wrap {
        margin-left: auto;
      }
      .board_sort {
        max-width: 168px;
        margin: 0;
      }
    }
  }
  // .btn_wrap {
  //   display: none;
  // }
}
@media (max-width: 480px) {
  .location_wrap {
    padding: 20px 35px 0px 35px;
  }
  .receive_registration {
    padding: 16px 10px;
  }
  .receive_registration .cancel_btn {
    width: 18px;
    height: 18px;
  }
  .receive_registration .left_sec p {
    gap: 3px;
    font-size: 11px;
  }
  .receive_registration .left_sec span {
    font-size: 14px;
  }
}
</style>
